"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCloseEvents = exports.closeEvents = void 0;
var AddBackorderDemandEvent = _interopRequireWildcard(require("@ori-events/add-backorder-demand"));
var AddPersonalSubscriptionEvent = _interopRequireWildcard(require("@ori-events/add-personal-subscription"));
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var ReplaceShoppingBagItem = _interopRequireWildcard(require("@ori-events/replace-shopping-bag-item"));
var ReplaceSubscriptionEvent = _interopRequireWildcard(require("@ori-events/replace-subscription"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const closeEvents = exports.closeEvents = [AddBackorderDemandEvent.Name, ReplaceShoppingBagItem.Name, ReplaceSubscriptionEvent.Name];
const useCloseEvents = ({
  onClose
}) => {
  const [closeEvent, setCloseEvent] = (0, _react.useState)();
  const onBasketUpdated = (0, _react.useCallback)(() => {
    if (closeEvent) {
      onClose();
      setCloseEvent(undefined);
    }
  }, [closeEvent, onClose]);
  const onAddPersonalSubscription = (0, _react.useCallback)(event => {
    const {
      detail: {
        lineNumber,
        originalQuantity
      }
    } = event;
    if (lineNumber != null && originalQuantity != null) {
      setCloseEvent(event);
    }
  }, []);
  const events = (0, _react.useMemo)(() => [...closeEvents.map(name => ({
    name,
    listener: setCloseEvent
  })), {
    name: AddPersonalSubscriptionEvent.Name,
    listener: onAddPersonalSubscription
  }, {
    name: BasketUpdatedEvent.Name,
    listener: onBasketUpdated
  }], [onAddPersonalSubscription, onBasketUpdated]);
  (0, _presentationHooks.useGlobalEvents)(events);
};
exports.useCloseEvents = useCloseEvents;
